module.exports = __webpack_public_path__ + "static/usluge_03-db45140dd82bc7d25406c84c9b936323.jpg";